// extracted by mini-css-extract-plugin
export default {"wrapper":"fpxoPX","floatingNotification":"rUSCCa"};